(function () {
    var model = angular.module('feedbackModule', []);

    model.controller(controllers.feedbackController, ['$scope', '$http', '$uibModal', 'feedBackService', '$uibModalInstance', 'model', '$sce', 'configService',
        function ($scope, $http, $uibModal, feedBackService, $modalInstance, model, $sce, configService) {

            var vm = this;

            $scope.globalResources = angular.copy(globalResources);
            $scope.globalResources.Feedback_Message = $sce.trustAsHtml(globalResources.Feedback_Message);
            $scope.globalResources.Feedback_Message1 = $sce.trustAsHtml(globalResources.Feedback_Message1);
            $scope.globalResources.FeedBackCheckLabel = $sce.trustAsHtml(globalResources.FeedBackCheckLabel);
            $scope.globalResources.FeedBackCheckLabelA = $sce.trustAsHtml(globalResources.FeedBackCheckLabelA);
            $scope.globalResources.FeedBackCheckLabelB = $sce.trustAsHtml(globalResources.FeedBackCheckLabelB);
            $scope.globalResources.FeedBackCheckLabelC = $sce.trustAsHtml(globalResources.FeedBackCheckLabelC);
            $scope.globalResources.FeedBackCheckLabelD = $sce.trustAsHtml(globalResources.FeedBackCheckLabelD);
            $scope.globalResources.FeedBackCheckLabelE = $sce.trustAsHtml(globalResources.FeedBackCheckLabelE);
            $scope.globalResources.FeedBackCheckLabelF = $sce.trustAsHtml(globalResources.FeedBackCheckLabelF);
            $scope.globalResources.FeedBackCheckLabelG = $sce.trustAsHtml(globalResources.FeedBackCheckLabelG);
            $scope.globalResources.FeedBackCheckLabelH = $sce.trustAsHtml(globalResources.FeedBackCheckLabelH);

            $scope.feedBackLabels = [
                { value: 1, text: $scope.globalResources.FeedBackCheckLabelA, positive: true, result: 0 },
                { value: 2, text: $scope.globalResources.FeedBackCheckLabelB, positive: true, result: 0 },
                { value: 1, text: $scope.globalResources.FeedBackCheckLabelD, positive: false, result: 0 },
                { value: 2, text: $scope.globalResources.FeedBackCheckLabelE, positive: false, result: 0 },
                { value: 4, text: $scope.globalResources.FeedBackCheckLabelF, positive: false, result: 0 },
                { value: 8, text: $scope.globalResources.FeedBackCheckLabelG, positive: false, result: 0 },
                { value: 16, text: $scope.globalResources.FeedBackCheckLabelH, positive: false, result: 0 }
            ];

            if (HandbookConfiguration.RecipientsForFeedbackMail == E.RecipientsForFeedbackMail.OwnerOnly) {
                $scope.isOwnerOnly = true;
            }

            vm.enableExtendedFeedback = configService.getBool(HandbookConfiguration.EnableExtendedFeedback);
            $scope.enableExtendedFeedback = vm.enableExtendedFeedback;

            $scope.currentData = {
				positive: model.positive,
                feedbackMessage: '',
                feedBack: 0,
                sendAlsoToApprover: false
            };

            $scope.sendFeedback = function () {
                if (vm.enableExtendedFeedback) {
                    const selectedOption = getSelectedFeedBack();
                    if (selectedOption) {
                        $scope.currentData.feedbackMessage = selectedOption + $scope.currentData.feedbackMessage;
					}
                }
                if (!validFeedBack()) {
                    alert(globalResources.PleaseEnterFeedback);
                    return false;
                }
                return feedBackService
					.sendFeedback(model.entityId, $scope.currentData)
                    .then(function (response) {
                        if (response) {
                            $modalInstance.close(true);
                            resetCurrentData();
                            alert(globalResources.ThanksForYourFeedback);
                        }
                    });
            };

            $scope.close = function () {
                $modalInstance.close(true);
            };

            $scope.calculateFeedBack = function () {
                var count = 0;

                var feedBackLabels = $scope.feedBackLabels || [];
                for (var i = 0; i < feedBackLabels.length; i++) {
                    var x = feedBackLabels[i];
                    if (parseInt(x.result) > 0) {
                        count = count + parseInt(x.result);
                    }
                }

                $scope.currentData.feedBack = count;
            }

            function validFeedBack() {
                if ($scope.currentData.feedbackMessage || $scope.currentData.feedBack) {
                    return true;
                }
                return false;
            }

            function resetCurrentData() {
                $scope.currentData.positive = null;
                $scope.currentData.feedbackMessage = '';
                $scope.currentData.feedBack = 0;
                $scope.currentData.sendAlsoToApprover = false;
            }

            function getSelectedFeedBack() {
                var value = '';

                var feedBackLabels = $scope.feedBackLabels || [];
                for (var i = 0; i < feedBackLabels.length; i++) {
                    var x = feedBackLabels[i];
                    if (parseInt(x.result) > 0) {
                        value = value + x.text + '\n';
                    }
                }

                return value;
            }

        }]);

})();